import type { CompareProduct } from '@iheartjane/menu';
import { productPhotoMetadata } from '@iheartjane/menu';

import type { ProductSearchResultViewModel } from '@jane/bloom/viewModels/productSearch';

type BuildCompareProductArgs = {
  /** Formatted display price (e.g. "$10.00"), if available */
  price?: string;
  /** Formatted full price before discounts (e.g. "$12.00"), if available */
  priceBeforeDiscounts?: string;
  /** Whether the display price is discounted from the full price */
  priceIsDiscounted?: string | boolean;
  product: ProductSearchResultViewModel;
};

const parsePrice = (formatted?: string): number | null =>
  formatted ? parseFloat(formatted.replace(/[^0-9.]/g, '')) : null;

export function buildCompareProduct({
  price,
  priceBeforeDiscounts,
  priceIsDiscounted,
  product,
}: BuildCompareProductArgs): CompareProduct {
  const { url: imageUrl } = productPhotoMetadata(product);

  return {
    activities: product.activities ?? [],
    aggregateRating: product.aggregate_rating,
    availableWeights: (product.available_weights as string[]) ?? [],
    brand: product.brand,
    category: product.category,
    cbdDosageMg: null,
    feelings: product.feelings ?? [],
    flavors: product.flavors?.map((f) => f.title) ?? [],
    id: product.product_id,
    imageUrl,
    kind: product.kind,
    name: product.name,
    originalPrice:
      priceIsDiscounted && priceBeforeDiscounts
        ? parsePrice(priceBeforeDiscounts)
        : null,
    percentCbd:
      product.percent_cbd != null ? Number(product.percent_cbd) : null,
    percentThc:
      product.percent_thc != null ? Number(product.percent_thc) : null,
    price: parsePrice(price),
    reviewCount:
      product.review_count != null ? Number(product.review_count) : null,
    thcDosageMg: null,
    url: `/products/${product.product_id}/${product.unique_slug ?? product.id}`,
    weight: product.dosage ?? null,
  };
}
